export default __webpack_public_path__ + "static/media/benefit_2@3x.ef11d40e.png";